<div class="table-container">
    @if (shouldShowEmptyState()) {
    <section class="empty-tracks-state" aria-labelledby="empty-tracks-title">
        <h2 id="empty-tracks-title" class="empty-tracks-title">
            No songs created yet
        </h2>
        <a class="empty-tracks-create-button" routerLink="/create">
            Create a song
        </a>
    </section>
    }
    <cdk-virtual-scroll-viewport
        itemSize="52"
        class="trackslist rounded-2xl limit-height relative">
        @if (isInFolder()){
        <div
            class="table-row folder-row back-folder-row grid px-3 gap-3 text-white"
            [ngStyle]="gridColumns"
            [class.bg-gray-600]="backRowSelected"
            [attr.data-track-folder-drop-id]="parentFolderID()"
            [class.drag-drop-target-active]="
                dragTargetFolderID === parentFolderID()
            "
            (click)="handleBackClick($event)"
            (dblclick)="goBack($event)">
            <div
                class="track-icon-cell flex justify-center w-full hover:cursor-pointer">
                <img src="assets/img/back.svg" class="rounded-md w-5" />
            </div>
            <table-tooltip
                [text]="'Back to ' + parentFolderName()"></table-tooltip>
        </div>
        }
        <div
            *cdkVirtualFor="let item of unionedData; let i = index"
            class="table-row grid px-3 gap-3 text-white"
            [ngClass]="{
                'track-row': isTrack(item),
                'folder-row': isFolder(item),
                'new-folder-entry':
                    isFolder(item) && animatedFolderID === item._id,
                'bg-gray-600': isSelected(item),
                'drag-source-row': isDragged(item),
                'drag-drop-target-active':
                    isFolder(item) && dragTargetFolderID === item._id,
                'hovered-background':
                    !isSelected(item) && hoveredItem?._id === item._id
            }"
            [ngStyle]="gridColumns"
            [attr.data-track-folder-drop-id]="isFolder(item) ? item._id : null"
            [attr.aria-busy]="isTrackTitlePending(item) ? 'true' : null"
            cdkDrag
            [cdkDragData]="item"
            [cdkDragDisabled]="moveInProgress || item._id === renamingItem?._id"
            [cdkDragStartDelay]="dragStartDelay"
            (cdkDragStarted)="startDragging($event, item)"
            (cdkDragMoved)="updateDragTarget($event)"
            (cdkDragEnded)="finishDragging($event)"
            (click)="handleRowClick($event, item)"
            (contextmenu)="setContextMenu($event, item)"
            (mouseenter)="hoveredItem = item"
            (mouseleave)="hoveredItem = undefined"
            (dblclick)="openFolder($event, item)">
            @if(isFolder(item)) {

            <span
                class="folder-icon track-icon-cell flex justify-center w-full hover:cursor-pointer">
                <img
                    src="assets/img/folder-tracks.svg"
                    alt=""
                    aria-hidden="true" />
            </span>

            <div class="track-title-cell truncate">
                <table-tooltip
                    [text]="item.name"
                    *ngIf="item._id !== renamingItem?._id"></table-tooltip>

                <input
                    (click)="preventOpen($event)"
                    (dblclick)="preventOpen($event)"
                    class="rename-input leading-8 w-full"
                    [(ngModel)]="item.name"
                    *ngIf="item._id === renamingItem?._id"
                    #renameInput
                    (keydown.enter)="confirmRename()"
                    (clickOutside)="confirmRename()" />
            </div>

            } @else {

            <span class="track-icon-cell">
                <div
                    class="loading-track-icon flex justify-center w-full"
                    *ngIf="!trackIsPartiallyLoaded(item)">
                    <round-progress
                        class="track-icon-loading"
                        [current]="item.loading"
                        [max]="100"
                        [stroke]="28"
                        [color]="'#00A2FF'"
                        [background]="
                            'rgba(240, 240, 255, 0.2)'
                        "></round-progress>
                </div>

                <div
                    *ngIf="
                        trackIsPartiallyLoaded(item) &&
                        isTrackPlaybackLoading(item)
                    "
                    class="loading-track-icon flex justify-center w-full"
                    role="status"
                    [attr.aria-label]="'Loading ' + item.name">
                    <div class="small-loader track-playback-loader"></div>
                </div>

                <button
                    type="button"
                    *ngIf="
                        trackIsPartiallyLoaded(item) &&
                        !isTrackPlaybackLoading(item)
                    "
                    class="track-song-button"
                    [attr.aria-label]="
                        (isTrackPlaying(item) ? 'Pause ' : 'Play ') + item.name
                    "
                    (click)="handlePlay(item)">
                    <img
                        *ngIf="hoveredItem?._id !== item._id"
                        class="track-song-icon"
                        src="assets/img/note.svg"
                        alt=""
                        aria-hidden="true" />
                    <span
                        *ngIf="hoveredItem?._id === item._id"
                        class="track-playback-overlay"
                        aria-hidden="true">
                        <img
                            [src]="
                                isTrackPlaying(item)
                                    ? 'assets/img/player/pause_filled.svg'
                                    : 'assets/img/player/player-filled.svg'
                            "
                            alt="" />
                    </span>
                </button>
            </span>
            <div class="track-title-cell truncate">
                <table-tooltip
                    (dblclick)="startRenaming($event, item)"
                    *ngIf="item._id !== renamingItem?._id"
                    [text]="item.name"></table-tooltip>
                <input
                    class="rename-input leading-8 w-full"
                    [(ngModel)]="item.name"
                    *ngIf="item._id === renamingItem?._id"
                    #renameInput
                    (keydown.enter)="confirmRename()"
                    (clickOutside)="confirmRename()" />
            </div>
            <span
                *ngIf="!(isMobile$ | async)"
                class="track-metadata cursor-default">
                {{ formatDuration(item) }}
            </span>
            <span
                *ngIf="!(isMobile$ | async)"
                class="track-metadata cursor-default">
                {{ getCreationDate(item) }}
            </span>

            <ng-container *ngIf="!(isMobile$ | async)">
                <!-- Keep unliked tracks visually quiet until row hover/focus. -->
                <button
                    type="button"
                    (click)="toggleLike($event, item)"
                    *ngIf="!item.liked"
                    class="row-action like-action unliked-like-action"
                    [attr.aria-label]="'Like ' + item.name">
                    <img src="assets/img/love.svg" alt="" aria-hidden="true" />
                </button>

                <!-- If item is liked  -->
                <button
                    type="button"
                    (click)="toggleLike($event, item)"
                    *ngIf="item.liked"
                    class="row-action like-action"
                    [class.liked-like-action--animated]="
                        animatingLikeTrackIDs.has(item._id)
                    "
                    (animationend)="finishLikeAnimation(item._id)"
                    [attr.aria-label]="'Unlike ' + item.name">
                    <img src="assets/img/loved.svg" alt="" aria-hidden="true" />
                </button>
            </ng-container>

            <button
                type="button"
                (click)="setContextMenu($event, item)"
                class="row-action more-action"
                [attr.aria-label]="'More options for ' + item.name">
                <img src="assets/img/more.svg" alt="" aria-hidden="true" />
            </button>
            }

            <ng-template cdkDragPreview>
                <div class="track-drag-preview">
                    <img
                        [src]="
                            draggingItems.length === 1 &&
                            isFolder(draggingItems[0])
                                ? 'assets/img/folder-tracks.svg'
                                : 'assets/img/navbar/projects.svg'
                        "
                        alt=""
                        aria-hidden="true" />
                    <span>{{ dragPreviewText() }}</span>
                </div>
            </ng-template>
        </div>
    </cdk-virtual-scroll-viewport>
</div>

<menu-options
    *ngIf="contextMenu !== undefined"
    [width]="230"
    [menuOptions]="contextMenu"
    [title]="contextMenu.title"
    (close)="setContextMenu($event, undefined)"></menu-options>
